import { formatNumber } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-yearreducedgas",
  templateUrl: "./yearreducedgas.component.html",
  standalone: false,
})
export class YearReducedgasComponent {
  @Input() public currentYearProduction: number;

  public getYearReduction(): string {
    const co2_gas_rate = 0.623;
    return formatNumber(this.currentYearProduction / 1000 * co2_gas_rate, "en", "1.0-1")+ " kg";
  }

}
